/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RejectRequest
 */
export interface RejectRequest {
    /**
     * 
     * @type {string}
     * @memberof RejectRequest
     */
    reason?: string;
}

/**
 * Check if a given object implements the RejectRequest interface.
 */
export function instanceOfRejectRequest(value: object): value is RejectRequest {
    return true;
}

export function RejectRequestFromJSON(json: any): RejectRequest {
    return RejectRequestFromJSONTyped(json, false);
}

export function RejectRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): RejectRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'reason': json['reason'] == null ? undefined : json['reason'],
    };
}

export function RejectRequestToJSON(json: any): RejectRequest {
    return RejectRequestToJSONTyped(json, false);
}

export function RejectRequestToJSONTyped(value?: RejectRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'reason': value['reason'],
    };
}

